import React from 'react'
import * as S from './styles'

const TutorPagination = ({ totalItems, currentPage, setCurrentPage, show }) => {
  const isFirstPage = () => {
    return currentPage === 1
  }

  const previousPage = () => {
    if (isFirstPage()) { return }
    setCurrentPage(currentPage - 1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const isLastPage = () => {
    return totalItems < 8
  }

  const nextPage = () => {
    if (isLastPage()) { return }
    setCurrentPage(currentPage + 1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return show && (
    <S.Container>
      <S.PaginationItem key={'first'} onClick={() => previousPage()}>
        <S.ChevronLeftIcon disabled={isFirstPage()} />
      </S.PaginationItem>
      <S.PaginationItem outline={true}>{currentPage}</S.PaginationItem>
      <S.PaginationItem key={'last'} onClick={() => nextPage()}>
        <S.ChevronRightIcon disabled={isLastPage()} />
      </S.PaginationItem>
    </S.Container>
  )
}

export default TutorPagination
